import { render, staticRenderFns } from "./ExtendOtherNutrientsStarches.vue?vue&type=template&id=18a84f0e&scoped=true"
import script from "./ExtendOtherNutrientsStarches.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsStarches.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsStarches.vue?vue&type=style&index=0&id=18a84f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a84f0e",
  null
  
)

export default component.exports